import type { UpdateCourseDraft200PriceCurrency } from './updateCourseDraft200PriceCurrency';

/**
 * 코스 가격 정보
 * @nullable
 */
export type UpdateCourseDraft200Price = {
  /**
   * 가격 (0은 무료)
   * @minimum 0
   */
  amount: number;
  /** 통화 코드 */
  currency: UpdateCourseDraft200PriceCurrency;
} | null;
